//本地枚举请到add-reference.js中添加
export const localReference = {
    localYesNoEnum: [{"label":"是","value":1,"key":"YES"},{"label":"否","value":0,"key":"NO"}],
    localIsViewEnum: [{"label":"未查看","value":0,"key":"NO_SEE"},{"label":"已查看","value":1,"key":"YES_SEE"}],
  }